import { Component } from '@theme/component';
import { VariantSelectedEvent, VariantUpdateEvent } from '@theme/events';
import { yieldToMainThread } from '@theme/utilities';

export default class Hub47ImagesSection extends Component {
    connectedCallback() {
        super.connectedCallback();
        const columns = 3;
        const productLinks = this.querySelectorAll("a");

        const sums = Array.from({ length: columns }, () => 0);
        const buckets = Array.from({ length: columns }, () => []);

        const heights = []
        for (const [idx, node] of productLinks.entries()) {    
            const height = node.offsetHeight;
            const shortestIndex = sums.indexOf(Math.min(...sums));
            buckets[shortestIndex].push(node);
            sums[shortestIndex] += height;
            heights.push(height);
        }
        for (const [column, elements] of buckets.entries()) {
            let currentRow = 0;
            for (const element of elements) {
                const rowStart = currentRow;
                const rowEnd = currentRow + parseInt( Math.round(element.offsetHeight / 10));
                console.log(`Should set column to ${column} / ${column} and row to ${rowStart} / ${rowEnd}`);
                element.style.gridColumn = `${column+1} / ${column+1}`;
                element.style.gridRowStart = rowStart + 1;
                element.style.gridRowEnd = rowEnd + 1;
                console.log(element.style);
                currentRow = rowEnd;
            }

        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }
};

if (!customElements.get('hub47-images-section')) {
  customElements.define('hub47-images-section', Hub47ImagesSection);
}

